/**
 * Color Swatch AJAX Navigation - PDP Only
 * Handles clicking color swatches to load different products without page reload
 * Preserves swatch order by updating visual state only
 */
const MAIN_PRODUCT_SELECTOR = 'section[id^="MainProduct-"]';
const SWATCH_SELECTOR = '.color-swatch-link';

function getSwatch(event) {
  const swatch = event.target.closest(SWATCH_SELECTOR);
  return swatch && !swatch.closest('quick-add-modal') ? swatch : null;
}

function getSection(element = document) {
  return element.closest?.(MAIN_PRODUCT_SELECTOR) || document.querySelector(MAIN_PRODUCT_SELECTOR);
}

function getLabel(section) {
  return section?.querySelector('[data-selected-color-name]');
}

function setLabel(section, colorName) {
  const label = getLabel(section);
  if (!label || !colorName) return;
  label.textContent = colorName;
}

function resetLabel(section) {
  const label = getLabel(section);
  if (!label) return;

  const currentSwatch = section.querySelector('.product-form-color-swatches .color-swatch-current');
  label.textContent = currentSwatch?.dataset.colorName || label.dataset.defaultColor || label.textContent;
}

document.addEventListener('click', async (event) => {
  const swatch = getSwatch(event);
  if (!swatch || swatch.classList.contains('color-swatch-current')) return;

  const url = swatch.dataset.url;
  if (!url) return;

  event.preventDefault();

  const currentSection = document.querySelector(MAIN_PRODUCT_SELECTOR);
  if (!currentSection) return (window.location.href = url);

  currentSection.style.opacity = '0.5';
  currentSection.style.pointerEvents = 'none';

  try {
    const response = await fetch(url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.querySelector(MAIN_PRODUCT_SELECTOR);

    if (!newSection) return (window.location.href = url);

    currentSection.replaceWith(newSection);
    history.replaceState({}, '', url);

    const newSwatchContainer = newSection.querySelector('.product-form-color-swatches');
    if (newSwatchContainer) {
      newSwatchContainer.querySelectorAll(SWATCH_SELECTOR).forEach((item) => item.classList.remove('color-swatch-current'));
      const currentSwatch = newSwatchContainer.querySelector(`${SWATCH_SELECTOR}[data-url="${url}"]`);
      if (currentSwatch) currentSwatch.classList.add('color-swatch-current');
      resetLabel(newSection);
    }

    // Re-run behaviors that were bound to old DOM nodes before section swap.
    window.enableProductZoomOnHover?.();
    // Re-run inline initializers (Tabby/Taly) — their scripts are inert after replaceWith.
    window.reinitReplacedProductSection?.(newSection);
    document.dispatchEvent(new CustomEvent('pdp:section-replaced', {
      detail: { section: newSection, url }
    }));

    window.Shopify?.PaymentButton?.init();
  } catch (error) {
    window.location.href = url;
  }
});

document.addEventListener('mouseover', (event) => {
  const swatch = getSwatch(event);
  if (!swatch) return;
  setLabel(getSection(swatch), swatch.dataset.colorName);
});

document.addEventListener('mouseout', (event) => {
  const swatch = getSwatch(event);
  if (!swatch || swatch.contains(event.relatedTarget)) return;
  resetLabel(getSection(swatch));
});

